<lib-live-pickup-aurora-background [colorStops]="auroraColorStops()" [amplitude]="0.9" [blend]="0.8"
  [speed]="0.8"></lib-live-pickup-aurora-background>

<lib-system-icons
  class="absolute right-12 top-10 z-20 max-sm:right-6 max-sm:top-6"
  iconName="logo-ediz-text"
  [iconFill]="'[&_path]:fill-black dark:[&_path]:fill-white'" [iconWidth]="logoWidth()">
  </lib-system-icons>

<lib-live-pickup-theme-switcher class="fixed bottom-8 right-8 z-20 max-sm:bottom-4 max-sm:right-4" />

<section
  class="font-open-sans absolute inset-0 overflow-y-auto custom-scrollbar-thin">
  <div
    class="flex min-h-full w-full flex-col items-center gap-[clamp(32px,5vh,80px)] px-12 pb-12 pt-[clamp(80px,15vh,150px)] max-sm:min-h-0 max-sm:gap-8 max-sm:px-6 max-sm:pt-[88px]">
    <h1 class="relative z-10 text-[clamp(1.75rem,2.6vw,2.5rem)] font-semibold text-foreground"
      style="text-wrap: balance">
      {{ 'ACCESS.CHECKIN.LIVE_PICKUP.SIGN_IN.TITLE' | translate }}
    </h1>

    <section class="relative z-10 w-full max-w-5xl">
      @if (hasError()) {
      <div class="mx-auto flex w-full max-w-2xl flex-col items-center gap-6 text-center max-sm:gap-4">
        <p class="text-[clamp(1.125rem,1.6vw,1.5rem)] font-normal text-foreground">
          {{ 'ACCESS.CHECKIN.LIVE_PICKUP.SIGN_IN.ERROR_MESSAGE' | translate }}
        </p>
        <button type="button"
          class="rounded-full border border-[color-mix(in_srgb,var(--foreground)_15%,transparent)] bg-[color-mix(in_srgb,var(--card)_30%,transparent)] px-6 py-3 text-[clamp(1rem,1.4vw,1.25rem)] font-semibold text-foreground backdrop-blur-2xl backdrop-saturate-150"
          (click)="retry()">
          {{ 'ACCESS.CHECKIN.LIVE_PICKUP.SIGN_IN.ERROR_RETRY' | translate }}
        </button>
      </div>
      } @else if (method() === 'phone') {
      <div class="grid grid-cols-1 gap-12 md:gap-16 lg:grid-cols-[1fr_auto_1fr] lg:gap-[80px] max-sm:gap-10">
        <div class="flex items-start gap-6 max-sm:flex-col max-sm:gap-3">
          <div class="flex min-w-0 flex-col gap-6 max-sm:w-full max-sm:gap-4">
            <div class="flex items-center gap-4 max-sm:gap-3">
              <span
                class="flex aspect-square w-[clamp(2.75rem,4.4vw,3.5rem)] shrink-0 items-center justify-center rounded-xl border border-[color-mix(in_srgb,var(--foreground)_15%,transparent)] bg-[color-mix(in_srgb,var(--card)_30%,transparent)] text-foreground-50 backdrop-blur-2xl backdrop-saturate-150">
                <i class="fi fi-rr-qrcode text-[clamp(1.1rem,1.9vw,1.6rem)] leading-[0]"></i>
              </span>
              <div class="flex min-w-0 flex-col gap-0.5">
                <span class="text-[clamp(1.125rem,1.7vw,1.5rem)] font-semibold text-foreground">
                  {{ 'ACCESS.CHECKIN.LIVE_PICKUP.SIGN_IN.METHOD_PHONE_TITLE' | translate }}
                </span>
                <span class="text-[clamp(0.85rem,1.2vw,1.05rem)] font-normal text-foreground-50">
                  {{ 'ACCESS.CHECKIN.LIVE_PICKUP.SIGN_IN.METHOD_PHONE_SUBTITLE' | translate }}
                </span>
              </div>
            </div>
            <p class="text-[clamp(1.125rem,1.6vw,1.5rem)] font-normal text-foreground">
              {{ 'ACCESS.CHECKIN.LIVE_PICKUP.SIGN_IN.PHONE_STEP_1' | translate }}
              <br />
              <span class="break-all font-bold text-foreground">{{ pairingUrl() }}</span>
            </p>
            @if (pairingUrl()) {
            <div class="w-fit rounded-2xl bg-white p-4 max-sm:mx-auto max-sm:p-3">
              <lib-qr-code [qrData]="pairingUrl()" [width]="qrWidth()" [margin]="1" [errorCorrectionLevel]="'H'"
                [imageSrc]="'assets/images/logo-ediz-symbol.svg'" [imageWidth]="qrLogoSize()"
                [imageHeight]="qrLogoSize()"></lib-qr-code>
            </div>
            } @else {
            <div class="animate-pulse rounded-2xl bg-[color-mix(in_srgb,var(--card)_30%,transparent)] max-sm:mx-auto"
              [style.width.px]="qrWidth() + 32" [style.height.px]="qrWidth() + 32">
            </div>
            }
          </div>
        </div>

        <div class="flex h-full select-none items-center justify-center gap-3 lg:flex-col lg:gap-4">
          <div class="h-px flex-1 bg-[color-mix(in_srgb,var(--foreground)_15%,transparent)] lg:h-auto lg:w-px"></div>
          <span class="-translate-y-[0.13em] text-[clamp(1rem,1.8vw,1.75rem)] font-medium leading-none text-foreground-75">
            {{ 'ACCESS.CHECKIN.LIVE_PICKUP.SIGN_IN.OR' | translate }}
          </span>
          <div class="h-px flex-1 bg-[color-mix(in_srgb,var(--foreground)_15%,transparent)] lg:h-auto lg:w-px"></div>
        </div>

        <div class="flex items-start gap-6 max-sm:flex-col max-sm:gap-3">
          <div class="flex min-w-0 flex-col gap-6 max-sm:w-full max-sm:gap-4">
            <div class="flex items-center gap-4 max-sm:gap-3">
              <span
                class="flex aspect-square w-[clamp(2.75rem,4.4vw,3.5rem)] shrink-0 items-center justify-center rounded-xl border border-[color-mix(in_srgb,var(--foreground)_15%,transparent)] bg-[color-mix(in_srgb,var(--card)_30%,transparent)] text-foreground-50 backdrop-blur-2xl backdrop-saturate-150">
                <i class="fi fi-rr-keyboard text-[clamp(1.1rem,1.9vw,1.6rem)] leading-[0]"></i>
              </span>
              <div class="flex min-w-0 flex-col gap-0.5">
                <span class="text-[clamp(1.125rem,1.7vw,1.5rem)] font-semibold text-foreground">
                  {{ 'ACCESS.CHECKIN.LIVE_PICKUP.SIGN_IN.METHOD_CODE_TITLE' | translate }}
                </span>
                <span class="text-[clamp(0.85rem,1.2vw,1.05rem)] font-normal text-foreground-50">
                  {{ 'ACCESS.CHECKIN.LIVE_PICKUP.SIGN_IN.METHOD_CODE_SUBTITLE' | translate }}
                </span>
              </div>
            </div>
            <p class="text-[clamp(1.125rem,1.6vw,1.5rem)] font-normal text-foreground">
              {{ 'ACCESS.CHECKIN.LIVE_PICKUP.SIGN_IN.PHONE_STEP_2' | translate }}
            </p>
            <div
              class="text-[clamp(2rem,3.5vw,3rem)] font-bold leading-none tabular-nums tracking-[0.05em] text-foreground max-sm:text-center">
              {{ pairingCode() || '— — — —' }}
            </div>
          </div>
        </div>
      </div>
      } @else {
      <div class="mx-auto flex w-full max-w-2xl flex-col items-center gap-6 text-center max-sm:gap-4">
        <p class="text-[clamp(1.125rem,1.6vw,1.5rem)] font-normal text-foreground">
          {{ 'ACCESS.CHECKIN.LIVE_PICKUP.SIGN_IN.REMOTE_INSTRUCTIONS' | translate }}
        </p>
        <div
          class="text-[clamp(2.5rem,6vw,5rem)] font-extrabold leading-none tabular-nums tracking-[0.05em] text-foreground">
          {{ pairingCode() || '— — — —' }}
        </div>
      </div>
      }
    </section>
  </div>
</section>
